<main class="renewal-page">
  <div class="back-row">
    <app-back-button></app-back-button>
  </div>

  <form [formGroup]="formRenovacao" class="renewal-card">
    <header class="renewal-header">
      <div class="header-main">
        <div class="header-icon" aria-hidden="true">
          <i class="pi pi-refresh"></i>
        </div>

        <div>
          <span class="eyebrow">
            Solicitação de renovação
            <ng-container *ngIf="solicitacao?.id">#{{ solicitacao.id }}</ng-container>
          </span>
          <h1>Renovação da bolsa</h1>
          <p>
            Consulte os dados académicos, documentos submetidos e o processo de validação.
          </p>
        </div>
      </div>

      <div class="request-status">
        <span class="status-label">Estado da solicitação</span>
        <p-tag [severity]="getSeverity(solicitacao?.estado)"
          [value]="getEstadoSolicitacao(solicitacao?.estado)"></p-tag>
        <span class="request-date" *ngIf="solicitacao?.data">
          <i class="pi pi-calendar"></i>
          {{ solicitacao.data | date:'dd/MM/yyyy, HH:mm' }}
        </span>
      </div>
    </header>

    <div class="sections-wrapper">
      <section class="detail-section">
        <div class="section-heading">
          <span class="section-icon"><i class="pi pi-user"></i></span>
          <div>
            <h2>Dados pessoais</h2>
            <p>Identificação do estudante associado à solicitação.</p>
          </div>
        </div>

        <div class="grid form-grid">
          <div class="field col-12 md:col-4">
            <label for="NumeroBI">Bilhete de identidade</label>
            <input id="NumeroBI" type="text" class="w-full" pInputText formControlName="NumeroBI" />
          </div>

          <div class="field col-12 md:col-8">
            <label for="nome">Nome completo</label>
            <input id="nome" type="text" class="w-full" pInputText formControlName="nome" />
          </div>
        </div>
      </section>

      <section class="detail-section">
        <div class="section-heading">
          <span class="section-icon"><i class="pi pi-graduation-cap"></i></span>
          <div>
            <h2>Dados da formação</h2>
            <p>Informação do curso e do período académico a renovar.</p>
          </div>
        </div>

        <div class="grid form-grid">
          <div class="field col-12 lg:col-7">
            <label for="instituicaoEnsinoNome">Instituição de ensino</label>
            <input pInputText type="hidden" formControlName="InstituicaoID" id="InstituicaoID" />
            <input pInputText formControlName="instituicaoEnsinoNome" class="w-full text-uppercase"
              id="instituicaoEnsinoNome" />
          </div>

          <div class="field col-12 lg:col-5">
            <label for="cursoDesignacao">Curso</label>
            <input pInputText type="hidden" formControlName="CursoID" id="CursoID" />
            <input pInputText formControlName="cursoDesignacao" class="w-full" id="cursoDesignacao" />
          </div>

          <div class="field col-12 sm:col-6 lg:col-3">
            <label for="DataInicio">Data de início</label>
            <p-datePicker formControlName="DataInicio" [showIcon]="true" class="w-full" inputId="DataInicio"
              dateFormat="dd/mm/yy"></p-datePicker>
          </div>

          <div class="field col-12 sm:col-6 lg:col-3">
            <label for="DataFim">Data de fim</label>
            <p-datePicker formControlName="DataFim" [showIcon]="true" class="w-full" inputId="DataFim"
              dateFormat="dd/mm/yy"></p-datePicker>
          </div>

          <div class="field col-12 sm:col-6 lg:col-3">
            <label for="duracao">Duração</label>
            <input id="duracao" type="text" class="w-full" pInputText formControlName="duracao" />
          </div>

          <div class="field col-12 sm:col-6 lg:col-3">
            <label for="estadoDesc">Estado da bolsa</label>
            <input pInputText type="hidden" formControlName="estadoBolsaID" id="estadoBolsaID" />
            <input pInputText formControlName="estadoDesc" class="w-full" id="estadoDesc" />
          </div>

          <div class="field col-12 sm:col-6 lg:col-4">
            <label for="AnoLetivoAnterior">Ano lectivo anterior</label>
            <input pInputText formControlName="AnoLetivoAnterior" class="w-full" id="AnoLetivoAnterior" />
          </div>

          <div class="field col-12 sm:col-6 lg:col-4">
            <label for="AnoLetivoAtivacao">Ano lectivo de activação</label>
            <input pInputText formControlName="AnoLetivoAtivacao" class="w-full" id="AnoLetivoAtivacao" />
          </div>

          <div class="field col-12 lg:col-4">
            <label for="anoCurricular">Ano curricular</label>
            <input pInputText formControlName="anoCurricular" class="w-full" id="anoCurricular" />
          </div>
        </div>
      </section>

      <section class="detail-section">
        <div class="section-heading">
          <span class="section-icon"><i class="pi pi-paperclip"></i></span>
          <div>
            <h2>Anexos</h2>
            <p>Documentos apresentados pelo estudante para a renovação.</p>
          </div>
          <span class="section-count">{{ docs.length }} documento(s)</span>
        </div>

        <div class="doc-list" *ngIf="docs.length; else semAnexos">
          <button type="button" class="doc-item" *ngFor="let d of docs" (click)="openPdf(d.file)"
            [attr.aria-label]="'Abrir ' + d.nome">
            <span class="doc-icon" aria-hidden="true">
              <i class="pi pi-file-pdf"></i>
            </span>
            <span class="doc-text">
              <span class="doc-name">{{ d.nome }}</span>
              <span class="doc-size">{{ d.tamanho }} · {{ d.extensao || 'PDF' }}</span>
            </span>
            <i class="pi pi-external-link doc-open-icon" aria-hidden="true"></i>
          </button>
        </div>

        <ng-template #semAnexos>
          <div class="empty-docs">
            <i class="pi pi-file"></i>
            <span>Nenhum anexo submetido.</span>
          </div>
        </ng-template>
      </section>

      <section class="detail-section validation-section">
        <div class="section-heading">
          <span class="section-icon"><i class="pi pi-verified"></i></span>
          <div>
            <h2>Processo de validação</h2>
            <p>Acompanhe os pareceres emitidos em cada etapa da solicitação.</p>
          </div>
        </div>

        <div class="validation-timeline">
          <div class="timeline-step is-approved">
            <span class="step-marker"><i class="pi pi-check"></i></span>
            <span class="step-content">
              <strong>Solicitação submetida</strong>
              <small>Concluído</small>
            </span>
          </div>

          <div class="timeline-step" [ngClass]="getParecerClass(solicitacao?.parecerEstudante)">
            <span class="step-marker">
              <i class="pi" [ngClass]="getParecerIcon(solicitacao?.parecerEstudante)"></i>
            </span>
            <span class="step-content">
              <strong>Estudante</strong>
              <small>{{ getParecerLabel(solicitacao?.parecerEstudante) }}</small>
            </span>
          </div>

          <div class="timeline-step" [ngClass]="getParecerClass(representanteParecer)">
            <span class="step-marker">
              <i class="pi" [ngClass]="getParecerIcon(representanteParecer)"></i>
            </span>
            <span class="step-content">
              <strong>Representante</strong>
              <small>{{ getParecerLabel(representanteParecer) }}</small>
            </span>
          </div>

          <div class="timeline-step" [ngClass]="getParecerClass(mirempetParecer)">
            <span class="step-marker">
              <i class="pi" [ngClass]="getParecerIcon(mirempetParecer)"></i>
            </span>
            <span class="step-content">
              <strong>MIREMPET</strong>
              <small>{{ getParecerLabel(mirempetParecer) }}</small>
            </span>
          </div>
        </div>

        <div class="grid opinion-grid">
          <div class="field col-12 md:col-4">
            <label for="parecerEstudante">Parecer do estudante</label>
            <p-select appendTo="body" class="w-full" formControlName="parecerEstudante" [options]="parecerOptions"
              optionLabel="label" optionValue="id"></p-select>
          </div>

          <div class="field col-12 md:col-4">
            <label for="parecerInstituicao">Parecer do representante</label>
            <p-select appendTo="body" class="w-full" formControlName="parecerInstituicao" [options]="parecerOptions"
              optionLabel="label" optionValue="id"></p-select>
          </div>

          <div class="field col-12 md:col-4" *ngIf="solicitacao?.parecerInstituicao != 3">
            <label for="parecerMIREMPET">
              {{ solicitacao?.parecerMIREMPET != 3 ? 'Parecer do MIREMPET' : 'Dar parecer' }}
            </label>
            <p-select appendTo="body" class="w-full" formControlName="parecerMIREMPET" placeholder="Selecione o parecer"
              [options]="parecerMirempetOptions" optionLabel="label" optionValue="id"></p-select>
            <small class="error-message" *ngIf="
                formRenovacao.get('parecerMIREMPET')?.invalid &&
                formRenovacao.get('parecerMIREMPET')?.touched
              ">
              O parecer é obrigatório.
            </small>
          </div>
        </div>
      </section>
    </div>

    <footer class="form-actions">
      <button pButton type="button" label="Voltar" icon="pi pi-arrow-left" class="p-button-outlined p-button-secondary"
        (click)="Return()"></button>
      <button pButton type="submit" label="Actualizar solicitação" icon="pi pi-check" class="p-button-primary"
        (click)="updateSolicitacao()" [disabled]="formRenovacao.invalid"
        *ngIf="formRenovacao.get('parecerMIREMPET')?.value != 3 && representanteParecer != 3"></button>
    </footer>
  </form>
</main>

<p-confirmDialog appendTo="body"></p-confirmDialog>
<p-toast></p-toast>